import { ProductListPriceFragment } from "@graphcommerce/magento-product/components/ProductListPrice/ProductListPrice.gql";

export default function DiscountBadge(props: ProductListPriceFragment) {
  const { discount } = props;
  return (
    <>
      {discount?.percent_off && discount?.percent_off > 0 ? <div className="!w-8 h-7 bg-red-500  text-white rounded-full text-sm font-medium flex items-center justify-center ltr">
        <span className="text-xs">%</span>{`${discount?.percent_off}`}
      </div> : null}
    </>

  )
}